const EventNotFound = () => {
  return (
    <h1 className="m-5 text-[28px] max-lg:text-[24px] max-sm:text-[22px]">
      Event not found :(
    </h1>
  );
};

export default EventNotFound;
